import BankAccountInput from './bank-account-input';

export default BankAccountInput;
